import styled from "styled-components";

import bgimage from "~/assets/asset01.png";
import vrioCorp from "~/assets/VrioFaq.png";
import imageCountry from "~/assets/Brazil.png";

export const Container = styled.div`
  height: 100%;
  background-color: #000;

  .message-alert {
    display: none;
  }

  @media (max-width: 768px) {
    .message-alert {
      button {
        color: #fff;
        background: rgb(49 49 49);
        border-radius: 50px;
        width: 64px;
        height: 64px;
        font-size: 2.6rem;
        position: absolute;
        top: -25px;
        right: -10px;
      }

      position: fixed;
      width: 90vw;
      height: 90vh;
      background: #000;
      z-index: 11;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 50px;
      flex-direction: column;
      margin: auto;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;

      h1 {
        color: #fff;
        font-size: 4rem;
      }

      img {
        height: 80px;
        max-width: 350px;
        margin: 70px 0;
        object-fit: contain;
      }

      .content-small {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 500px;
        min-width: 360px;
        width: 100%;
        height: 90px;

        .vrio-corp {
          height: 90px;
          display: flex;
          align-items: center;

          span {
            background-image: url(${vrioCorp});
            background-repeat: no-repeat;
            width: 161px;
            height: 67%;
            text-indent: -5000em;
            display: inline-block;
            background-size: cover;
            background-position-y: center;
            margin-right: 40px;
          }
        }

        .image-country {
          span {
            background-image: url(${imageCountry});
            background-repeat: no-repeat;
            background-position: center;
            width: 300px;
            height: 300px;
            text-indent: -5000em;
            display: inline-block;
            background-size: contain;
          }
        }

        .welcome {
          flex-direction: column;
          display: flex;
          justify-content: center;
          border-left: 1px solid #fff;
          padding-left: 30px;

          h2 {
            color: #707070;
            font-size: 3.5rem;
            margin: 0;
          }
          h1 {
            margin: 0;
            color: #fff;
            font-size: 3.6rem;
          }
        }
      }
    }
  }

  @media (max-width: 468px) {
    .message-alert {
      h1 {
        color: #fff;
        font-size: 3rem;
      }

      img {
        height: 50px;
        max-width: 230px;
        margin: 30px 0;
        object-fit: contain;
      }

      .content-small {
        .vrio-corp {
          height: auto;

          span {
            width: 90px;
            height: 100%;
            background-size: contain;
            border-right: 1px solid #fff;
            margin-right: 40px;
          }
        }

        .welcome {
          border-left: none;
          padding-left: 0;

          h2 {
            color: #707070;
            font-size: 1.5rem;
            margin: 0;
          }
          h1 {
            margin: 0;
            color: #fff;
            font-size: 1.6rem;
          }
        }
      }
    }
  }
`;

export const Header = styled.header`
  width: 100%;
  height: 70px;
  padding: 0 20px;
  background: #131313;
  display: flex;
  align-items: center;
  justify-content: center;

  .content-header-faq {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    .logo {
      background-image: url(${(props) => props.theme.colors.logoVrio});
      background-repeat: no-repeat;
      height: 30px;
      width: 100px;
      text-indent: -5000em;
      display: inline-block;
      background-size: contain;
    }

    .login {
      height: 100%;

      a {
        text-decoration: none;

        button {
          height: 100%;
          padding: 0 20px;
        }

        span {
          color: ${(props) => props.theme.colors.primaryText};
          font-size: 1.6rem;
        }
      }
    }
  }
`;

export const Content = styled.div`
  .heade-options {
    max-width: 1200px;
    width: 100%;
    margin: 40px auto;

    > ul {
      display: flex;
      list-style: none;
      flex-wrap: wrap;

      > li {
        align-items: center;
        display: flex;
        padding: 10px 15px;
        height: 10px;

        > a {
          color: white;
        }

        & + li {
          border-left: 1px solid white;
        }
      }
    }
  }

  width: 100%;
  min-height: 90vh;
  background: ${(props) => props.theme.colors.primaryBackground};
  display: flex;
  flex-direction: column;

  .content-header {
    width: 100%;
    height: 200px;

    background-image: url(${bgimage});
    opacity: 0.9;
    background-repeat: no-repeat;
    background-position-y: center;
    background-size: cover;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1,
    h4 {
      color: #fff;
    }

    h1 {
      font-size: 46px;
    }

    h4 {
      font-size: 26px;
      text-align: center;
    }
  }

  .faq-question-fix {
    max-width: 1200px;
    margin: 50px auto 0;
    padding: 0 20px;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: white;
    }

    h3,
    p {
      color: ${(props) => props.theme.colors.primaryText};
      line-height: 2.2rem;
      margin-bottom: 20px;
    }

    h3 {
      text-align: center;
      margin-bottom: 50px;
      text-transform: uppercase;
    }

    ul {
      padding: 0 30px;
      margin: 30px 0;

      li {
        color: ${(props) => props.theme.colors.primaryText};
        line-height: 2.2rem;
        margin: 20px 0;
      }
    }
  }

  .faq-question {
    max-width: 1200px;
    width: 100%;
    margin: 10px auto 50px;
    padding: 0 20px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: white;
    }

    ul {
      padding: 0 30px;

      li {
        color: ${(props) => props.theme.colors.primaryText};
        line-height: 2.2rem;
        margin: 20px 0;
      }
    }

    .title {
      font-size: 2rem;
    }

    .content {
      font-size: 1.5rem;
    }

    .MuiPaper-root {
      background: none;
      color: ${(props) => props.theme.colors.primaryText};
      border: 1px solid #929292;
      margin: 20px 0px;

      .MuiIconButton-root {
        color: ${(props) => props.theme.colors.primaryText};
      }
    }
  }

  .document-question-fix {
    max-width: 1200px;
    margin: 50px auto 0;
    padding: 0 20px;
    padding-bottom: 40px;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: white;
    }

    h3,
    p {
      color: ${(props) => props.theme.colors.primaryText};
      line-height: 2.2rem;
      margin-bottom: 20px;
    }

    h3 {
      text-align: left;
      margin-top: 50px;
      padding: 15px 0;
      border-bottom: 1px solid #ccc;
      text-transform: uppercase;
    }

    ul {
      padding: 0 30px;
      margin: 30px 0;

      li {
        color: ${(props) => props.theme.colors.primaryText};
        line-height: 2.2rem;
        margin: 20px 0;
      }
    }
  }
`;
